module.exports = __webpack_public_path__ + "static/media/gr.940e2b6f.svg";